import { NewContactIframeModalBody } from './modal-body';
import { NewContactIframeModalHeader } from './modal-header';
import styles from './styles.module.scss';
import useLockScroll from 'hooks/use-lock-scroll';
import { FC } from 'react';

type Props = {
  onClose: () => void;
  contactId: number;
};

const NewContactIframeModal: FC<Props> = ({ onClose, contactId }) => {
  useLockScroll();

  return (
    <>
      <div className="modal fade show d-block" role="dialog" tabIndex={-1} aria-modal="true">
        {/* begin::Modal dialog */}
        <div className={`${styles.modalDialog} modal-dialog modal-dialog-centered modal-xl`}>
          {/* begin::Modal content */}
          <div className={`${styles.modalContent} modal-content`}>
            <NewContactIframeModalHeader onClose={onClose} />
            {/* begin::Modal body */}
            <div className="modal-body">
              <NewContactIframeModalBody contactId={contactId} />
            </div>
            {/* end::Modal body */}
          </div>
          {/* end::Modal content */}
        </div>
        {/* end::Modal dialog */}
      </div>
      {/* begin::Modal Backdrop */}
      <div className="modal-backdrop fade show"></div>
      {/* end::Modal Backdrop */}
    </>
  );
};

export default NewContactIframeModal;
